import styled from '@emotion/styled'

export const Wrapper = styled.div`
  position: fixed;
  top: var(--space-0);
  left: var(--space-0);
  width: 100%;
  height: 100%;
  background: var(--primitive-transparent-black-48);
  z-index: 9999;
`
